<template>
    <div role="alert" :class="`mensagem mensagem_cor-${tipoDeMensagem} u-sem-margem`">
        <div class="mensagem__container-icone">
            <i v-if="tipoDeMensagem == 'sucesso'" class="far fa-check-circle mensagem__icone"></i>
            <i v-if="tipoDeMensagem == 'erro'" class="far fa-info-circle mensagem__icone"></i>
            <i v-if="tipoDeMensagem == 'atencao'" class="far fa-exclamation-circle mensagem__icone"></i>
        </div>
        <div class="mensagem__conteudo">
            <h2 v-if="tipoDeMensagem == 'erro'" class="mensagem__titulo">Parcelas em atraso</h2>
            <p class="mensagem__texto">
                {{mensagem}}
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: "mensagemDeAviso",
    props: [
        'mensagem',
        'tipoDeMensagem'
    ]
}
</script>
